export default "__VITE_ASSET__3WJjHQYk__"